export const GET_ID_VERIFICATION_SUCCESS = 'idVerificationPopUp/GET_ID_VERIFICATION_SUCCESS'

export const LOAD_ACTION = 'idVerificationPopUp/LOAD_ACTION'
export const ERROR_ACTION = 'idVerificationPopUp/ERROR_ACTION'

export const idVerificationPopUpConstantsBlackList = [LOAD_ACTION, ERROR_ACTION]
